"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var product_1 = require("../../model/product");
var service_1 = require("../../../library/base/service");
var MoreDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MoreDetail, _super);
    function MoreDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '更多详情接口';
        _this.code = '101041';
        _this.desc = '更多详情接口';
        _this.requestParams = new product_1.MoreDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MoreDetail;
}(service_1.BaseService));
exports.MoreDetail = MoreDetail;
//# sourceMappingURL=moreDetail.js.map